module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Edit patient data","Medical history":"Medical history"},"es":{"title":"Editar datos del paciente","Medical history":"Historial médico"}}')
  delete Component.options._Ctor
}
